import { Navigate, useNavigate } from 'react-router-dom';
import { Avatar, Button, Grid, Text } from '@ltvco/refresh-lib/theme';
import { useSession } from '@ltvco/refresh-lib/v1';
import { SidenavContainer } from 'components/sidenav/SidenavContainer';
import notFound from '../images/img_404.svg';

export function NotFound() {
  const navigate = useNavigate();
  const {
    session: { isAuthenticated },
  } = useSession(); // should be replaced by the user_info object

  function goToDashboard() {
    navigate('/dashboard/home');
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SidenavContainer>
      <Grid container spacing={3} textAlign={'center'} marginTop={8}>
        <Grid size={12}>
          <Avatar
            src={notFound}
            alt="404"
            sx={{ width: 88, height: 88, margin: 'auto' }}
            variant="square"
          />
          <Text variant="h2" color={'primary'} fontSize={52} marginTop={2.5}>
            404
          </Text>
          <Text variant="h3" fontSize={24} marginTop={2.5}>
            This page isn't available
          </Text>
          <Text width={{ xs: '100%', md: '30%' }} margin={'auto'}>
            We searched high and low, but we couldn't find the page you're
            looking for
          </Text>
          <Button
            variant="contained"
            sx={{ marginTop: 2.5 }}
            onClick={goToDashboard}
          >
            Go to Dashboard
          </Button>
        </Grid>
      </Grid>
    </SidenavContainer>
  );
}
